import styled from 'styled-components';
import { scrollBlueStyles } from '../../../styles/sharedStyles';

export const StyledScrollHeader = styled.div`
    width: calc(100% - 104px);
    overflow-x: scroll;

    ${scrollBlueStyles};
`;
